import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-navy px-5 py-12 sm:py-20" data-id="element-62" data-mp="1hbgu4bwv3v38">
      <div className="mx-auto max-w-2xl" data-id="element-63" data-mp="1cfjfca18ywsk">
        <h2 className="text-center font-display text-2xl font-bold text-white sm:text-4xl" data-id="element-64" data-mp="1ccnd49id9lyb">
          Frequently Asked Questions
        </h2>
        <div className="mt-8 divide-y divide-gold/30 border-y border-gold/30" data-id="element-65" data-mp="252w0qgvo8yka">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <div key={faq.question} data-id="element-66" data-mp="1v5hicbq6tzpc" data-mpi={index}>
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex min-h-[48px] w-full items-center justify-between gap-4 py-4 text-left" data-id="element-67" data-mp="1v4g6w659fb73">
                  <span className="text-sm font-semibold text-white sm:text-base" data-id="element-68" data-mp="1kp1mhhueyptj">
                    {faq.question}
                  </span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gold/15 text-gold" data-id="element-69" data-mp="1pkgwfypaw1ko">
                    {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-70" data-mp="1fnc9hwnms22t" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-71" data-mp="11wgx4adxb2uh" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-72" data-mp="16ps88nprq5s7">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-73" data-mp="rwyebx9r1n40">
                      <p className="pb-4 text-sm leading-relaxed text-white/70" data-id="element-74" data-mp="2pnor6x71i4x6">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}